/** Estado de vista compartido entre paneles: escala y desplazamiento en px del panel. */
export interface ViewState {
  scale: number;
  tx: number;
  ty: number;
}

export const IDENTITY_VIEW: ViewState = { scale: 1, tx: 0, ty: 0 };
export const MIN_SCALE = 1;
export const MAX_SCALE = 8;

export function clamp(v: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, v));
}

/**
 * Restringe el desplazamiento para que el contenido escalado siga cubriendo el panel
 * (no se puede «perder» la imagen arrastrando).
 */
export function clampView(v: ViewState, width: number, height: number): ViewState {
  const scale = clamp(v.scale, MIN_SCALE, MAX_SCALE);
  const minTx = width - width * scale;
  const minTy = height - height * scale;
  return { scale, tx: clamp(v.tx, minTx, 0), ty: clamp(v.ty, minTy, 0) };
}

/** Zoom alrededor de un punto (px del panel) manteniendo fijo el contenido bajo el cursor. */
export function zoomAt(v: ViewState, factor: number, px: number, py: number, width: number, height: number): ViewState {
  const scale = clamp(v.scale * factor, MIN_SCALE, MAX_SCALE);
  const k = scale / v.scale;
  return clampView({ scale, tx: px - (px - v.tx) * k, ty: py - (py - v.ty) * k }, width, height);
}

export function panBy(v: ViewState, dx: number, dy: number, width: number, height: number): ViewState {
  return clampView({ ...v, tx: v.tx + dx, ty: v.ty + dy }, width, height);
}

/** Convierte un punto del panel (px) a coordenadas normalizadas del contenido [0,1]. */
export function panelToContent(v: ViewState, px: number, py: number, width: number, height: number): { x: number; y: number } {
  return { x: (px - v.tx) / v.scale / width, y: (py - v.ty) / v.scale / height };
}
